// Quem grava precisa avisar que ha coisa nova para subir -- mas sem conhecer o
// sincronizador, que por sua vez ja importa o outbox: importar de volta faria um
// ciclo. Entao o sincronizador deixa aqui como se executa, e quem grava so pede.
//
// Enquanto ninguem registrar (testes de unidade do outbox, por exemplo), pedir e
// silencioso de proposito: gravar no aparelho nunca pode falhar por causa do envio.

type ExecutorDeSync = () => void

let executor: ExecutorDeSync | null = null

export function definirExecutorDeSync(fn: ExecutorDeSync | null): void {
  executor = fn
}

export function pedirSync(): void {
  executor?.()
}
